import { useMemo } from "react";
import { useFetcher } from "~/hooks/useFetcher";
import { conversationSkillsPath } from "~/services/conversations";
import { PartialSkill, SkillPage } from "~/services/skills";

interface UseSkillsResult {
  skills: PartialSkill[];
  isLoading: boolean;
}

// Fetches the skills available to the current conversation in a single request
// to the conversation-scoped endpoint. The conversations-service resolves the
// filter triple and returns the deduped USER + AGENT + DATASET union the
// orchestrator injects into the prompt — the frontend owns no recipe, no
// dataset resolution, and no client-side dedup. Re-keys when `conversationId`
// changes, so switching conversations refreshes the list.
export function useSkills(conversationId: string): UseSkillsResult {
  const { data, isLoading } = useFetcher<SkillPage>(conversationSkillsPath(conversationId));

  const skills = useMemo(
    () => [...(data?.items ?? [])].sort((a, b) => a.name.localeCompare(b.name)),
    [data]
  );

  return { skills, isLoading };
}
